import styled from 'styled-components';
import PropTypes from 'prop-types';
import { width, height, space, borderRadius, boxShadow, } from 'styled-system';
import propTypes from '@styled-system/prop-types';
import { borderRadiusAttrs, borderRadiusValues, boxShadowAttrs, boxShadowSizeValues, paletteFamilies, roundedValues, objectFitValues, objectPositionValues, objectFit, objectPosition, } from '../utils';
const imagePropTypes = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, propTypes.borderRadius), propTypes.boxShadow), propTypes.height), propTypes.space), propTypes.width), { borderRadiusSize: PropTypes.oneOf(borderRadiusValues), rounded: PropTypes.oneOf(roundedValues), boxShadowSize: PropTypes.oneOf(boxShadowSizeValues), boxShadowColor: PropTypes.oneOf(paletteFamilies), objectFit: PropTypes.oneOf(objectFitValues), objectPosition: PropTypes.oneOf(objectPositionValues) });
const Image = styled.img.attrs((props) => (Object.assign(Object.assign({}, borderRadiusAttrs(props)), boxShadowAttrs(props)))) `
  display: block;
  max-width: 100%;
  ${height};
  ${space};
  ${width};

  ${borderRadius}
  ${boxShadow}
  ${objectFit}
  ${objectPosition}
`;
Image.displayName = 'Image';
Image.propTypes = imagePropTypes;
Image.defaultProps = {
    boxShadowColor: 'border',
};
export default Image;
//# sourceMappingURL=Image.js.map